import axios from './axios';

const resetPassword = (postData) => {
  return axios.post('mfapi/auth/forgot-password/confirm/', postData);
};

const requestPasswordResetOTP = (postData) => {
  return axios.post('mfapi/auth/forgot-password/otp/', postData);
};

const verifyPasswordResetOTP = (postData) => {
  return axios.post('mfapi/auth/forgot-password/otp/verify/', postData);
};

const resendPasswordOTP = (postData) => {
  return axios.post('mfapi/auth/forgot-password/otp/resend/', postData);
};

export { resetPassword, requestPasswordResetOTP, verifyPasswordResetOTP, resendPasswordOTP };